import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-connection-entity-brand-chip',
  imports: [CommonModule],
  templateUrl: './connection-entity-brand-chip.component.html',
  styleUrl: './connection-entity-brand-chip.component.scss',
})
export class ConnectionEntityBrandChipComponent {
  @Input({ required: true }) displayName = '';
  @Input() iconUrl: string | null = null;

  get initial(): string {
    return this.displayName.trim()[0]?.toUpperCase() ?? '?';
  }
}
